const riskAlert = (riskAlertJson) => {
  const properties = {
    ...riskAlertJson.attributes,
    guid: riskAlertJson.guid,
  };
  return Object.assign(properties);
};

export default riskAlert;
